import styled from "@emotion/styled";

import { Box } from "@/components/layout/flexbox";

export const StyledStickyBox = styled(Box)`
  position: sticky;
  bottom: -36px;
  padding-top: 48px;
  padding-bottom: 36px;
  z-index: 99;
  background: linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.7),
    rgba(255, 255, 255, 0.95),
    rgba(255, 255, 255, 0.99),
    rgba(255, 255, 255, 0.99),
    rgba(255, 255, 255, 0.99),
    rgba(255, 255, 255, 0.99),
    rgba(255, 255, 255, 0.99),
    rgb(255, 255, 255)
  );
`;
